import AssignmentIcon from '@material-ui/icons/Assignment';
import { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import eventsAPI, { Event, FounderNoteReportData } from '../../api/events';
import { getRoutePath, Pages } from '../../router/constants';
import PopupIcon from '../common/popup-icon';

interface FounderNotesIconProps {
  session: Event;
}

function FounderNotesIcon({ session }: FounderNotesIconProps) {
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [founderNotesReport, setFounderNotesReport] =
    useState<FounderNoteReportData | null>(null);

  const fetchFounderNotesReport = useCallback(async () => {
    try {
      if (!session.founderReportId) {
        return;
      }

      setIsLoading(true);
      const lastFounderReportData = await eventsAPI.getFounderReportLast(
        session.id,
      );
      setFounderNotesReport(lastFounderReportData);
    } catch (e) {
      console.error(e);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [session.founderReportId, session.id]);

  return (
    <PopupIcon
      to={{
        pathname: getRoutePath(Pages.SESSIONS_NOTES, {
          sessionId: session.id,
        }),
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
        search: 'anchor=founder-notes-report-note',
      }}
      icon={<AssignmentIcon />}
      testId='founder-notes-icon'
      content={founderNotesReport?.content}
      emptyText='The report is not submitted.'
      errorText='Something went wrong... Please try again later.'
      isNoIcon={!session.founderReportId}
      isLoading={isLoading}
      isError={isError}
      onHover={fetchFounderNotesReport}
    />
  );
}

export default FounderNotesIcon;
